import { render, staticRenderFns } from "./IframeContentPreview.vue?vue&type=template&id=480ef8d3&scoped=true"
import script from "./IframeContentPreview.vue?vue&type=script&lang=js"
export * from "./IframeContentPreview.vue?vue&type=script&lang=js"
import style0 from "./IframeContentPreview.vue?vue&type=style&index=0&id=480ef8d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ef8d3",
  null
  
)

export default component.exports